import React from 'react';
import type { ReactNode } from 'react';
import styled from 'styled-components';
import FullPageFormContainer from 'components/full-page-form-container';

const AuthSection = styled.section<{ isEmailNotification?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.entryModalBg};
  color: ${({ theme }) => theme.colors.text};
  margin: 0px 0px;
  padding: ${({ theme: { grid } }) => grid.units(1)};
  box-shadow: 0 1px 10px 1px hsla(0, 0%, 65%, 0.5);
  border: 1px solid hsla(0, 0%, 65%, 0.3);

  button {
    width: 100%;
  }
`;

const Title = styled.h3`
  margin: 0.5em 0 1em 0;
`;

interface AuthContainerProps {
  children?: ReactNode;
  title?: ReactNode;
  isEmailNotification?: boolean;
}

const AuthContainer = ({ children, title, isEmailNotification }: AuthContainerProps): React.JSX.Element => (
  <FullPageFormContainer>
    <AuthSection isEmailNotification={isEmailNotification}>
      {title && <Title>{title}</Title>}
      {children}
    </AuthSection>
  </FullPageFormContainer>
);

export default AuthContainer;
